import { useLoadingStore } from '@/modules/core/stores/loadingStore'
import { raterGuard } from './guards'
import type { RouteLocationNormalized, NavigationGuardNext, RouteRecordRaw } from 'vue-router'
import { usePetsStore as usePetsRaterStore } from '@/modules/pets/rater/stores'
import { usePetsStore } from '@/modules/pets/hiring/stores'
import ModifyInsuranceModal from '@/modules/pets/rater/views/modals/ModifyInsuranceModal.vue'
import BranchEnum from '@/modules/core/models/BranchEnum'
import SpanishBranches from '@/modules/core/models/SpanishBranches'

const RATER_TITLE = 'Precios y Tarifas de los Seguros de Mascotas | ASISA'
const RATER_DESCRIPTION =
  'Obtén el mejor precio del seguro ASISA para tu mascota. Coberturas completas y tarifas ASISA adaptadas a tu mascota.'

export const PETS_RATER_ROUTES = [
  {
    path: SpanishBranches.pets,
    name: 'rater-pets',
    component: () => import('../modules/pets/rater/views/BaseView.vue'),
    meta: {
      title: RATER_TITLE,
      description: RATER_DESCRIPTION,
      branchName: BranchEnum.PETS
    },
    beforeEnter: async (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing-almost-got-it')
      await raterGuard(to, from, next)
    }
  },
  {
    path: `${SpanishBranches.pets}/:productCode/:clientCode`,
    name: 'pets-product',
    component: () => import('../modules/common/rater/views/ProductBaseView.vue'),
    meta: {
      title: RATER_TITLE,
      description: RATER_DESCRIPTION,
      branchName: BranchEnum.PETS
    },
    props: () => ({
      store: usePetsRaterStore(),
      modifyModal: ModifyInsuranceModal,
      omitStopLoading: true
    }),
    beforeEnter: async (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing')
      await raterGuard(to, from, next)
    }
  },
  {
    path: `${SpanishBranches.pets}/propuestas`,
    name: 'pets-insurance-proposals',
    component: () => import('@/modules/common/rater/views/ProductProposalsView.vue'),
    meta: {
      title: RATER_TITLE,
      description: RATER_DESCRIPTION,
      branchName: BranchEnum.PETS
    },
    props: () => ({
      store: usePetsRaterStore(),
      modifyModal: ModifyInsuranceModal,
      subheader: {
        label: 'components.InsuredSubheaderComponent.pets',
        iconSingle: 'icon-pets',
        iconMultiple: 'icon-pets'
      }
    }),
    beforeEnter: async (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing')
      await raterGuard(to, from, next)
    }
  }
] as RouteRecordRaw[]

export const PETS_HIRING_ROUTES = [
  {
    path: `${SpanishBranches.pets}/:id`,
    name: 'hiring-pets',
    component: () => import('../modules/pets/hiring/views/BaseView.vue'),
    meta: {
      title: 'Seguros Médicos ASISA',
      branchName: BranchEnum.PETS
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing', 'common.loading.starting-hiring')
      raterGuard(to, from, next)
    }
  },
  {
    path: `${SpanishBranches.pets}/completado/:hash`,
    name: 'pets-hiring-done',
    meta: {
      title: 'Seguros Médicos ASISA',
      branchName: BranchEnum.PETS
    },
    component: () => import('../modules/common/hiring/views/EmittedView.vue'),
    props: {
      emissionServiceCallback: (quotationId: string) => {
        return usePetsStore().getEmittedPolicyStatus(quotationId)
      },
      branchName: BranchEnum.PETS
    }
  }
] as RouteRecordRaw[]
